
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompaniesFilterState {
  selectedCategories: string[];
  selectedEmployees: string[];
  selectedProductCount: string[];
  selectedSubcategories: string[];
  selectedModalities: string[];
  selectedTags: string[];
  selectedDiscounts: string[];
  selectedAddOns: string[];
  slugFilter: string;
}

const initialState: CompaniesFilterState = {
  selectedCategories: ['All'],
  selectedEmployees: ['All'],
  selectedProductCount: ['All'],
  selectedSubcategories: ['All'],
  selectedModalities: ['All'],
  selectedTags: ['All'],
  selectedDiscounts: ['All'],
  selectedAddOns: ['All'],
  slugFilter: '',
};

const companiesFilterSlice = createSlice({
  name: 'companiesFilter',
  initialState,
  reducers: {
    setSelectedCategories: (state, action: PayloadAction<string[]>) => {
      state.selectedCategories = action.payload;
    },
    setSelectedEmployees: (state, action: PayloadAction<string[]>) => {
      state.selectedEmployees = action.payload;
    },
    setSelectedProductCount: (state, action: PayloadAction<string[]>) => {
      state.selectedProductCount = action.payload;
    },
    setSelectedSubcategories: (state, action: PayloadAction<string[]>) => {
      state.selectedSubcategories = action.payload;
    },
    setSelectedModalities: (state, action: PayloadAction<string[]>) => {
      state.selectedModalities = action.payload;
    },
    setSelectedTags: (state, action: PayloadAction<string[]>) => {
      state.selectedTags = action.payload;
    },
    setSelectedDiscounts: (state, action: PayloadAction<string[]>) => {
      state.selectedDiscounts = action.payload;
    },
    setSelectedAddOns: (state, action: PayloadAction<string[]>) => {
      state.selectedAddOns = action.payload;
    },
    setSlugFilter: (state, action: PayloadAction<string>) => {
      state.slugFilter = action.payload;
    },
    resetFilters: (state) => {
      state.selectedCategories = ['All'];
      state.selectedEmployees = ['All'];
      state.selectedProductCount = ['All'];
      state.selectedSubcategories = ['All'];
      state.selectedModalities = ['All'];
      state.selectedTags = ['All'];
      state.selectedDiscounts = ['All'];
      state.selectedAddOns = ['All'];
      state.slugFilter = '';
    },
  },
});

export const { 
  setSelectedCategories, 
  setSelectedEmployees, 
  setSelectedProductCount,
  setSelectedSubcategories,
  setSelectedModalities,
  setSelectedTags,
  setSelectedDiscounts,
  setSelectedAddOns,
  setSlugFilter,
  resetFilters 
} = companiesFilterSlice.actions;
export default companiesFilterSlice.reducer;
